
import React from 'react';

interface UrbanZaikhaLogoProps {
  size?: 'small' | 'large' | 'hero';
  className?: string;
}

export const UrbanZaikhaLogo: React.FC<UrbanZaikhaLogoProps> = ({ size = 'large', className }) => {
  const sizeClasses = {
    small: 'h-16 w-16', // For header
    large: 'h-48 w-48', // For loader
    hero: 'h-32 w-32',  // For hero section
  };

  return (
    <img
      src="/images/Urban Zaikha Logo.png"
      alt="Urban Zaikha Logo"
      className={`${sizeClasses[size]} object-contain ${className || ''}`}
      aria-label="Urban Zaikha Logo"
    />
  );
};
